<!-- backend/src/components/Cards/CardUserPermission.svelte -->
<script>
  import { onMount } from 'svelte';
  import { gostergeList, userList, userGostergeAdd, userGostergeUpdate } from '../../Api.svelte';
  import { userGosStore, selectedUserGostPer, isPerEditing } from '../../stores/stores.js';

  let gostergeler = [];
  let users = [];
  let selectedUser = '';
  let selectedGid = new Set();
  let u_id = null; 
  let editing = false;

  selectedUserGostPer.subscribe(gPer => {
    if (gPer) {
      u_id = gPer._id;
      selectedUser = gPer.user_id;
      selectedGid = new Set(gPer.gosterge_id); // Burada gosterge_id olarak ayarladım
    }
  });

  isPerEditing.subscribe(value => {
    editing = value;
  });

  async function submitForm() {
    if (editing) {
      await updateUserGosterge();
    } else {
      await addUserGosterge();
    }
  }

  async function addUserGosterge() {
    const selectedGidArray = Array.from(selectedGid);
    const result = await userGostergeAdd(selectedUser, selectedGidArray);
    if (result) {
      userGosStore.set(result);
      resetForm();
    } else {
      console.error('Kullanıcı ekleme başarısız.');
    }
  }

  async function updateUserGosterge() {
    const selectedGidArray = Array.from(selectedGid);
    const result = await userGostergeUpdate(selectedUser, selectedGidArray);
    if (result) {
      userGosStore.set(result);
      isPerEditing.set(false); // Düzenleme modu kapatılır
      resetForm();
    } else {
      console.error('Kullanıcı güncelleme başarısız.');
    }
  }

  function resetForm() {
    u_id = null;
    selectedUser = '';
    selectedGid = new Set();
    editing=false;
  }

  onMount(async () => {
    gostergeler = await gostergeList();
    gostergeler = gostergeler.reverse();
    users = await userList();
  });

  function toggleGostergeSelection(gId) {
    if (selectedGid.has(gId)) {
      selectedGid.delete(gId);
    } else {
      selectedGid.add(gId);
    }
    selectedGid = new Set(selectedGid);
  }
</script>

<!-- Form ve diğer kodlar buraya gelir -->


<div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
  <div class="rounded-t bg-white mb-0 px-6 py-4">
    <div class="text-center flex justify-between">
      <h6 class="text-blueGray-700 text-xl font-bold">Kullanıcı Gösterge Yetkilendirme</h6>
      <div class="flex items-center justify-end">
      <button class="{editing ? 'bg-lightBlue-400' : 'bg-red-400'} text-white active:{editing ? 'bg-lightBlue-500' : 'bg-red-500'} font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150" type="button" on:click="{submitForm}">
        {editing ? 'Düzenle' : 'Kaydet'}
      </button>
      <button class="bg-gray-400 text-white active:bg-gray-500 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ml-1 ease-linear transition-all duration-150" type="button" on:click="{resetForm}">
        {editing ? 'Temizle': 'İptal'}
      </button>
    </div>
  </div>
  </div>

  <div class="flex-auto px-4 lg:px-10 py-8 pt-0">
    <form on:submit|preventDefault="{submitForm}">
      <div class="flex mt-4 flex-wrap">
        <!-- Kullanıcı Adı Alanı -->
        <div class="w-full lg:w-12/12 px-4">
          <div class="relative w-full lg:w-4/12 mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-password">
              Kullanıcı Seçiniz
            </label>
            <div class="relative">
              <select class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline" bind:value={selectedUser} required disabled={editing}>
                <option value="" disabled selected hidden>Seçiniz</option>
                {#each users as user}
                  <option value={user._id}>{user.uname}</option>
                {/each}
              </select>
            </div>
          </div>
        </div>
        <!-- Gostergeler -->
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <div class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              Gosterge Seçiniz
            </div>
            <div class="flex flex-wrap">
              {#each gostergeler as gosterge}
                {#if !selectedGid.has(gosterge._id)}
                  <button type="button"  title="{gosterge.name}" class="w-32 h-10 truncate  border-0 px-3 py-2 m-1 rounded text-sm shadow focus:outline-none ease-linear transition-all duration-150 bg-white text-blueGray-600" on:click="{() => toggleGostergeSelection(gosterge._id)}">
                    {gosterge.name}
                  </button>
                {/if}
              {/each}
            </div>
          </div>
        </div>
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <div class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              Seçilen Göstergeler
            </div>
            <div class="flex flex-wrap">
              {#each gostergeler as gosterge}
                {#if selectedGid.has(gosterge._id)}
                  <button type="button"  title="{gosterge.name}"  class="w-32 h-10 truncate border-0 px-3 py-2 m-1 rounded text-sm shadow focus:outline-none ease-linear transition-all duration-150 bg-emerald-500 text-white" on:click="{() => toggleGostergeSelection(gosterge._id)}">
                    {gosterge.name}
                  </button>
                {/if}
              {/each}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
